import { render, staticRenderFns } from "./SliderWork.vue?vue&type=template&id=263cd70a&"
import script from "./SliderWork.vue?vue&type=script&lang=js&"
export * from "./SliderWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports